var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentStatMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1120_10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8242 32.6676C21.7164 32.6692 21.6083 32.67 21.5 32.67C11.835 32.67 4 26.1782 4 18.17C4 10.1619 11.835 3.67004 21.5 3.67004C31.165 3.67004 39 10.1619 39 18.17C39 20.1953 38.4989 22.1236 37.5938 23.8745C36.3794 26.3498 34.5051 28.5589 32.472 30.4645C29.3743 33.3682 25.7901 35.56 23.2378 36.7954C22.5627 37.1221 21.8242 36.6105 21.8242 35.8979V32.6676ZM15.5 18.92C15.5 20.3008 14.3807 21.42 13 21.42C11.6193 21.42 10.5 20.3008 10.5 18.92C10.5 17.5393 11.6193 16.42 13 16.42C14.3807 16.42 15.5 17.5393 15.5 18.92ZM21.5 21.42C22.8807 21.42 24 20.3008 24 18.92C24 17.5393 22.8807 16.42 21.5 16.42C20.1193 16.42 19 17.5393 19 18.92C19 20.3008 20.1193 21.42 21.5 21.42ZM32.5 18.92C32.5 20.3008 31.3807 21.42 30 21.42C28.6193 21.42 27.5 20.3008 27.5 18.92C27.5 17.5393 28.6193 16.42 30 16.42C31.3807 16.42 32.5 17.5393 32.5 18.92Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 32.67C31.165 32.67 39 26.1782 39 18.17C39 10.1619 31.165 3.67004 21.5 3.67004C11.835 3.67004 4 10.1619 4 18.17C4 26.1782 11.835 32.67 21.5 32.67ZM13 21.42C14.3807 21.42 15.5 20.3008 15.5 18.92C15.5 17.5393 14.3807 16.42 13 16.42C11.6193 16.42 10.5 17.5393 10.5 18.92C10.5 20.3008 11.6193 21.42 13 21.42ZM24 18.92C24 20.3008 22.8807 21.42 21.5 21.42C20.1193 21.42 19 20.3008 19 18.92C19 17.5393 20.1193 16.42 21.5 16.42C22.8807 16.42 24 17.5393 24 18.92ZM30 21.42C31.3807 21.42 32.5 20.3008 32.5 18.92C32.5 17.5393 31.3807 16.42 30 16.42C28.6193 16.42 27.5 17.5393 27.5 18.92C27.5 20.3008 28.6193 21.42 30 21.42Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1120_10",
    x: 0,
    y: 0.0000439584,
    width: 43,
    height: 41.2262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1120_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1120_10",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentStatMessage);
export default __webpack_public_path__ + "static/media/content-stat-message.aacd8fef5035e829e73f0f1253cfc637.svg";
export { ForwardRef as ReactComponent };